import React, {useState, useEffect, useContext} from 'react';

import TranslationContext from '../../../../../context/TranslationContext';
import UserContext from '../../../../../context/UserContext';
import {api} from "../../../../../api/api";
import PhoneInsertField from "../../PhoneInput";
import InsertField from "../../../../common/InsertField"
import {getErrorByStatus, getState, nowStamp, prepPhone, storeState} from "../../helpers";
import Button from '../../../../common/Button'


const VoipCallDescription = ({gate, isCallback = false}) => {
    
    return (<>
            <span className="phone_info mb-2">Вам будет совершен звонок с номера</span>
            <p className="phone_info mb-2">{prepPhone(gate)}</p>
            {
                isCallback
                ? <span className="phone_info mb-2">Последние 4 цифры номера входящего звонка являются кодом.</span>
                : <span className="phone_info mb-2">Робот помощник произнесет код.</span>
            }
            <span className="phone_info mb-2">Срок действия кода 120 секунд</span><br/>
    </>)
}

const VoipAction = ({setAccess, handlerBackBtn}) => {
    const {getTranslation} = useContext(TranslationContext)
    const {setApiWait} = useContext(UserContext)

    const [ phone, setPhone ] = useState("")
    const [ error, setError ] = useState("")
    const [ retryCount, setRetryCount ] = useState(20)
    const [ errMessage, setErrorMsg ] = useState("")
    const [ getGateSuccess, setGetGateSuccess ] = useState(false)
    const [ gate, setGate ] = useState("74993332211")
    const [ isCallback, setIsCallback] = useState(false)
    const [ showResend, setShowResend] = useState(true)
    const [ otp, setOtp ] = useState("")

    const otpChangeHandler = (evt) => {
        setOtp(v => {
            return evt.target.validity.valid
                ? evt.target.value
                : v
        })
    }
    useEffect(() => {
        if (error !== "") {
            if (getTranslation(error)!=="") {setErrorMsg(getTranslation(error))} else {setErrorMsg(error)}  
        }
    },[getTranslation, error])

    useEffect(() => {
        if (otp.length===4) {
            checkOtpWithPhone()
        }
    },[otp])

    useEffect(()=>{
        const phone = getState("user_phone")
        const gate = getState("voipGate")
        const exp = getState("voipGateExp")
        const resended = !!getState("voipOtpResend")
        const isCallback = !!getState("voipIsCallback")
        const expiration = parseInt(exp, 10)
        if (phone !== "" && gate !== "" && expiration > nowStamp()) {
            setGate(gate)
            setGetGateSuccess(true)
            setIsCallback(isCallback)
            if (!resended) {
                runCountdown()
                return
            }
            setShowResend(!resended)
        } 
        
    },[])

    const runCountdown = () => {
        let timer = setInterval(() => {
            setRetryCount((prevProgress) => {
                return prevProgress <= 0 ? 0 : prevProgress - 1
            })
            return () => clearInterval(timer)
        }, 1000)
    }

    const requestGetGate = () => {
        const regex = /^((8|\+7)[\- ]?)?(\(?\d{3}\)?[\- ]?)?[\d\- ]{7,10}$/

        if (phone === "") {
            setError("no_num")
        } else if (!regex.test(phone)) {
            setError("wrong_num")
        } else {
            setError("")
            setApiWait(true)
            storeState("user_phone", phone)
            api.getVoipGate(phone).then(res => {
                if (res.data.gate!=='') {
                    setGate(res.data.gate)
                    storeState("voipGate", res.data.gate)
                    storeState("voipGateExp", res.data.timeout)
                    setGetGateSuccess(true)
                    if (res.data.message === 'callback') {
                        setIsCallback(true)
                        storeState("voipIsCallback", true)
                    }
                    runCountdown()
                } else {setError("Неизвестный ответ API")}
            }).catch( err => {getErrorByStatus(err.response.status, setError, getTranslation)})
            .finally(()=>setApiWait(false))
        }
    }

    const resendViaSms = () => {
        setError("")
        setApiWait(true)
        api.getVoipChallengeToSms(phone).then(res => {
            if (res.status !== 200) {
                setError("Неизвестный ответ API")
            }
            if (res.data.message === "not_expired") {
                setError(getTranslation('info_reply_sms').split("[MIN]").join(`${res.data.timeout}`))
            }
            storeState("voipOtpResend", true)
            storeState("smsExpire", nowStamp() + res.data.timeout)
            setShowResend(false)
        }
        ).catch(err => {getErrorByStatus(err.response.status, setError, getTranslation)})
        .finally(()=>setApiWait(false))
    }

    const checkOtpWithPhone = () => {
        if (otp === "") {
            setError('info_check')
        } else {
            setError("")
            setApiWait(true)
            api.checkOtpCall(phone, otp).then(res=>{
                if (res.data.status === 'ok' || res.data.status ==='already') {
                    setAccess(true)
                }
            }).catch(err=> {
                if (getState("voipOtpResend") && err.response.status === 400) {
                    api.getOtpChallenger(phone, otp).then(res=>{
                        if (res.data.status === 'ok' || res.data.status ==='already') {
                            setAccess(true)
                        }
                    })
                }
                getErrorByStatus(err.response.status, setError, getTranslation)})
            .finally(()=>setApiWait(false))
        }
    }

    return (<>
            <span data-id_phrase="no_num" >{getTranslation("no_num")}</span>
            <PhoneInsertField
                phoneSetter={setPhone}
                turnOffStatus={getGateSuccess}
            />
            {
                error !== "" && <p id="error" data-id_phrase={error} >{errMessage}</p>
            }
            {
                getGateSuccess ? 
                <>
                    <VoipCallDescription 
                        gate={gate}
                        isCallback={isCallback}
                    />
                    <span style={{marginBottom: "1rem"}} data-id_phrase="sms_code_text">{getTranslation("sms_code_text")}</span>
                    <InsertField
                        type="password"
                        value={otp}
                        onChange={otpChangeHandler}
                        pattern='[0-9]*'
                    />
                    {
                    showResend && <Button idPhrase={"retry"} 
                        description={`${(retryCount!==0) ? `Повторить ${retryCount} сек` : 'Отправить в СМС'}`}
                        disabled={(retryCount!==0)} 
                        onClick={resendViaSms}/>
                    }
                </>
                :<> 
                    <p className="mb-2">Вам поступит звонок</p>
                    <Button idPhrase={"btn_sms"} onClick={requestGetGate}/>
                </>
            }
            <Button idPhrase={"back"} onClick={() => handlerBackBtn()}/>
    </>)
}


export default VoipAction;